import { makeAutoObservable } from 'mobx'

/**
 * @class BudgetStore
 * @description This class represents the store for budget. It manages the state of budget and is part of the root store.
 */
class BudgetStore {
	/**
	 * @property {Object} budget - An object containing budget indexed by their IDs.
	 */
	budget = {}

	/**
	 * @constructor
	 * @param {Object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of BudgetStore and makes it observable.
	 */
	constructor(rootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this)
	}
}

export default BudgetStore
